/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var JoveWebhookAction;

(function (JoveWebhookAction) {
  JoveWebhookAction["DOCUMENT_UPLOADED"] = "document_uploaded";
  JoveWebhookAction["CONTRACT_REQUIREMENT_CHANGED"] = "contract_requirement_changed";
  JoveWebhookAction["VALIDATION_RESULT_CHANGED"] = "validation_result_changed";
})(JoveWebhookAction || (JoveWebhookAction = {}));